import React, { useState } from 'react'
import { t } from '../../i18n/i18n'
import { DataClassification, FinancialYear, FinancialYearStatus } from '../../api/schemas/schema'
import { makeStyles, tokens } from '@fluentui/react-components'
import { IItemState } from '../../interfaces/IItemState'
import { GridItem } from '../common/grid/GridItem'
import { Grid } from '../common/grid/Grid'
import TextOutput from '../common/inputs/TextOutput'
import { UserAvatarOutput } from '../common/inputs/UserAvatarOutput'
import { translateEnumValue } from '../../helpers/enumHelper'
import { ModalEditFinancialYear } from './ModalEditFinancialYear'
import { InformationCard } from '../common/card/InformationCard'
import { FinancialYearInformationBarChart } from './FinancialYearInformationBarChart'
import { formatDate, formatToSwedishCrowns } from '../../helpers/stringHelper'

const useStyles = makeStyles({
   editButton: {
      display: 'flex',
      alignItems: 'center',
      '@media screen and (max-width: 1007px)': {
         justifyContent: 'end',
      },
   },
   infoWrapper: {
      '& > *': {
         marginTop: tokens.spacingVerticalXXXL,
      },
      '@media screen and (max-width: 1007px)': {
         '& > :first-child': {
            marginTop: 0,
         },
      },
   },
})

type InformationProps = {
   financialYearState: IItemState<FinancialYear>
   setFinancialYearState: React.Dispatch<React.SetStateAction<IItemState<FinancialYear>>>
}
export const FinancialYearInformation = ({ financialYearState, setFinancialYearState }: InformationProps) => {
   const classes = useStyles()
   const [isModalOpen, setIsModalOpen] = useState(false)
   const financialYear = financialYearState.item

   const handleEditButtonClick = () => {
      setIsModalOpen(true)
   }
   return (
      <>
         <InformationCard
            setState={setFinancialYearState}
            handleEditButtonClick={handleEditButtonClick}
            disabled={financialYearState.disabled || financialYear.status !== FinancialYearStatus.Ongoing}
            noMaxHeight
         >
            <Grid>
               <FinancialYearInformationBarChart costs={financialYear.costs} />

               <GridItem size={'3/12'} className={classes.infoWrapper}>
                  <TextOutput label={t('FinancialYear')} text={financialYear.name} />
                  <TextOutput label={t('Period')} text={`${formatDate(financialYear.startDate)} ${t('To')} ${formatDate(financialYear.endDate)}`} />
                  <UserAvatarOutput label={t('Owner')} userAccount={financialYear.owner} />
                  <TextOutput label={t('Workplace')} text={financialYear.workplaces.map((x) => x.name).join(', ')} />
                  <TextOutput label={t('InformationManagement')} text={translateEnumValue(DataClassification, financialYear.dataClassification)} />
                  <TextOutput
                     label={t('BudgetedRevenue')}
                     text={
                        financialYear.budgetedRevenue || financialYear.budgetedRevenue === 0
                           ? `${formatToSwedishCrowns(financialYear.budgetedRevenue)} kr`
                           : '-'
                     }
                  />
                  <TextOutput label={t('Comment')} text={financialYear.comment || '-'} />
               </GridItem>
            </Grid>
         </InformationCard>

         <ModalEditFinancialYear
            setFinancialYearState={setFinancialYearState}
            open={isModalOpen}
            setOpen={setIsModalOpen}
            financialYearState={financialYearState}
         />
      </>
   )
}
